import { render, staticRenderFns } from "./SidBoxShadow.vue?vue&type=template&id=ded099f2"
import script from "./SidBoxShadow.vue?vue&type=script&lang=js"
export * from "./SidBoxShadow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports